import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8fa91efa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "checkout-address-viewer"
}
const _hoisted_2 = {
  key: 0,
  class: "checkout-address-viewer__text"
}
const _hoisted_3 = {
  key: 1,
  class: "checkout-address-viewer__text"
}
const _hoisted_4 = {
  key: 2,
  class: "checkout-address-viewer__text"
}
const _hoisted_5 = {
  key: 3,
  class: "checkout-address-viewer__text"
}
const _hoisted_6 = {
  key: 4,
  class: "checkout-address-viewer__text"
}
const _hoisted_7 = {
  key: 5,
  class: "checkout-address-viewer__text"
}
const _hoisted_8 = {
  key: 6,
  class: "checkout-address-viewer__text"
}
const _hoisted_9 = {
  key: 7,
  class: "checkout-address-viewer__text"
}
const _hoisted_10 = {
  key: 8,
  class: "checkout-address-viewer__text"
}
const _hoisted_11 = {
  key: 9,
  class: "checkout-address-viewer__text"
}

import { PropType } from "vue";
import { ICustomerAddress } from "@/models/ICustomerAddress";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckoutAddressViewer',
  props: {
  address: {
    type: Object as PropType<ICustomerAddress>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.address)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.address.fullName)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.address.fullName), 1))
          : _createCommentVNode("", true),
        (__props.address.attention)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.address.attention), 1))
          : _createCommentVNode("", true),
        (__props.address.organizationNumber)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.address.organizationNumber), 1))
          : _createCommentVNode("", true),
        (__props.address.ean)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.address.ean), 1))
          : _createCommentVNode("", true),
        (__props.address.address)
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.address.address), 1))
          : _createCommentVNode("", true),
        (__props.address.address2)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.address.address2), 1))
          : _createCommentVNode("", true),
        (__props.address.zipcode && __props.address.city)
          ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.address.zipcode) + ", " + _toDisplayString(__props.address.city), 1))
          : _createCommentVNode("", true),
        (__props.address.email)
          ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.address.email), 1))
          : _createCommentVNode("", true),
        (__props.address.phoneNumber)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.address.phoneNumber), 1))
          : _createCommentVNode("", true),
        (__props.address.reference)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(__props.address.reference), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})